import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";

@Component({
  selector: 'app-inputrenderer',
  templateUrl: './inputrenderer.component.html',
  styleUrls: ['./inputrenderer.component.css']
})
export class InputrendererComponent implements ICellRendererAngularComp  {

  public params: any;
  public value:any;
  
      agInit(params: any): void {
          this.params = params;
          this.value = this.params.data.verfied_hours;
      }
  
      refresh(): boolean {
          return false;
      }
      onKeyDown(event): void {
        
        if (!this.isKeyPressedNumeric(event) ) {
            
            if (event.preventDefault){
                event.preventDefault();
            } 
        }
    }
    private isKeyPressedNumeric(event): boolean {
      const charCode = this.getCharCodeFromEvent(event);
      const charStr = event.key ? event.key : String.fromCharCode(charCode);
      if(charStr==="Backspace" || charStr==="Delete" || charStr===".")
      {
          return true;
      }
     
     if(this.isCharNumeric(charStr))
     {
         
          return true;
 
     }
    }
    private getCharCodeFromEvent(event): any {
      event = event || window.event;
      return (typeof event.which === "undefined") ? event.keyCode : event.which;
    }
    private isCharNumeric(charStr): boolean {
       
      return !!/\d/.test(charStr);
    }

}



// WEBPACK FOOTER //
// ./src/app/inputrenderer/inputrenderer.component.ts